import axios from 'axios';

const ROOT = 'api/v1/finance/ledger-events';

const FinLedgerEventApi = {
  calculatePendingElligoEvents() {
    return axios.post(`${ROOT}/process-pending-elligo-events`);
  },
  createInvoice(data) {
    return axios.post(`${ROOT}/client/invoice`, data);
  },
  editInvoice(data) {
    return axios.put(`${ROOT}/client/invoice/edit`, data);
  },
  getCreatedInvoice(invoiceNumber, invoiceType, params = {}) {
    return axios.get(`${ROOT}/client/invoice/${invoiceNumber}/type/${invoiceType}`, { params });
  },
  generateInvoiceNumber() {
    return axios.post(`${ROOT}/client/invoice-number`);
  },
  getLedgerEventsByFilter(filterProperty) {
    return axios.post(`${ROOT}/search`, filterProperty);
  }
};

export default FinLedgerEventApi;
